<template>
	<div>
		<v-alert type="error" v-show="showAlertError">
			{{ txt.errorMessage }}
		</v-alert>
		<v-alert type="success" v-show="showAlertSuccess">
			{{ txt.successMessage }}
		</v-alert>
		<v-progress-circular
			indeterminate
			color="primary"
			v-show="loadingData"
		/>
		<v-toolbar dense>
			<template v-slot:extension>
				<v-tabs
					v-model="tab"
					align-with-title
				>
					<v-tabs-slider color="black"/>
					<v-tab key="manageAccount">{{txt.manageAccounts}}</v-tab>
				</v-tabs>
			</template>
		</v-toolbar>

		<v-tabs-items v-model="tab">
			<v-tab-item key="manageAccount">
				<v-container class="keycloakManagement">
					<h2>{{txt.manageAccountsTab.keyCloakUserManagment}}</h2>
					<v-text-field
						v-model="search"
						append-icon="mdi-magnify"
						label="Search"
						single-line
						hide-details
						@input="getDataFromApiSearch"
					></v-text-field>
					<v-data-table
						:headers="headers"
						:items="userlist"
						:search="search"
						class="elevation-1"
						:page="currentPageNumber"
						:items-per-page="itemsPerPage"
						:server-items-length="totalNumberOfUsers"
						:footer-props="{
							'items-per-page-options': [itemsPerPage],
						}"
						:options.sync="pagination"
					>
						<template v-slot:[`item.actions`]="{ item }">
							<v-icon medium class="mr-3" @click.stop="openEditDialog(item)">mdi-pencil</v-icon>
							<v-icon medium class="mr-3" @click="deleteUser(item)">mdi-delete</v-icon>
							<v-icon medium class="mr-3" @click="resetPassword(item)">mdi-lock-reset</v-icon>
						</template>
					</v-data-table>

					<!-- Dialog for deleting user -->
					<dialog-before-action
						:maxWidthOfPanel="400"
						header="Are you sure you want to delete the user?"
						:model="dialogConfirmDeleteUser"
						:key="deleteDialogKey"
						:payload="selectedUserForDeleting"
						@primaryConfirmed="deleteUserClick"
						@secondaryConfirmed="dialogConfirmDeleteUser=false"
					></dialog-before-action>

					<!-- Dialog for editing user -->
					<v-dialog
						v-model="dialogEditUser"
						max-width="1000"
					>
						<v-card>
							<v-card-title class="headline">Edit User {{selectedUser.email}}</v-card-title>
							<div class="formEdit">
								<user-rights-overview
									:rights="selectedUserRights"
									:selectedUser="selectedUser"
									@confirmedEditRight="confirmedEditRight"
									@deleteRight="deleteRight"
									@rightAdded="onRightAdded"
									@userDetailsSaved="onUserDetailsSaved"
								/>
							</div>
						</v-card>
					</v-dialog>

					<!-- Dialog for passwort reset -->
					<dialog-before-action
						:maxWidthOfPanel="450"
						header="Reset Password"
						:body="resetPasswordDialogBody"
						:model="dialogConfirmPasswordChange"
						:key="passwordDialogKey"
						:payload="selectedUser"
						@primaryConfirmed="changePasswordClick"
						@secondaryConfirmed="dialogConfirmPasswordChange=false"
					></dialog-before-action>


					<!-- create new user -->
					<v-btn color="primary" outlined class="createNewUserBtn" @click="dialogCreateUser=true">
						<v-icon class="createNewUserBtnIcon">mdi-account-plus</v-icon>
						{{txt.btn.createNewUser}}
					</v-btn>
					<create-new-user
						:show="dialogCreateUser"
						:key="dialogCreateUser+Math.random()"
						@changeShowDialog="dialogCreateUser=false"
						@userCreated="getUsers"
						@userCreationFinalized="showSuccessMessage"
						@errorOccured="handleError"
					>
					</create-new-user>
				</v-container>
			</v-tab-item>
		</v-tabs-items>
	</div>
</template>

<script>
import axios from 'axios'
import UserRightsOverview from './UserRightsOverview.vue'
import DialogBeforeAction from '../../arcCustom/DialogBeforeAction.vue'
import CreateNewUser from './CreateNewUser.vue'
import debounce from 'lodash.debounce'

export default {
	name: 'AdminKeycloak',
	components: {
		UserRightsOverview,
		DialogBeforeAction,
		CreateNewUser,
	},
	data() {
		return {
			tab: null,
			txt: {
				usernameExistsAlert: 'User with that username or email already exists!',
				errorMessage: '',
				successMessage: '',
				btn: {
					createNewUser: 'Create a new user',
				},
				manageAccounts: 'Manage accounts',
				manageAccountsTab: {
					keyCloakUserManagment: 'Keycloak user management',
				},
			},
			headers: [
				// { text: 'Username', value: 'username' },
				{ text: 'Email', value: 'email' },
				{ text: 'First Name', value: 'firstname' },
				{ text: 'Last Name', value: 'lastname' },
				{ text: 'Actions', value: 'actions', sortable: false },
			],
			search: '',
			userlist: [],
			dialogEditUser: false,
			dialogCreateUser: false,
			dialogConfirmDeleteUser: false,
			dialogConfirmPasswordChange: false,
			deleteDialogKey: 0,
			passwordDialogKey: 0,
			isMounted: false,
			selectedUserForDeleting: {},
			selectedUser: {},
			selectedUserRights: [],
			showAlertSuccess: false,
			showAlertError: false,
			showUsernameExistsAlert: false,
			loadingData: false,
			currentPageNumber: 1,
			itemsPerPage: 25,
			totalNumberOfUsers: 0,
			pagination: {
				rowsPerPage: 25,
				descending: false,
				page: 1,
			},
			basePagination: {
				rowsPerPage: 25,
				descending: false,
				page: 1,
			},
			shouldPaginate: true,
			successfulDeleteMessage: '',
		}
	},
	computed: {
		resetPasswordDialogBody() {
			return `Are you sure you want to reset password of ${this.selectedUser.email}?
			The email with the new temporary password will be sent directly to ${this.selectedUser.email}.`
		},
	},
	methods: {
		handleError(error) {
			window.scrollTo(0, 0)
			this.showAlertError = true
			if (error && error.response && error.response.data) {
				this.txt.errorMessage = error.response.data.message || error.response.data
			} else this.txt.errorMessage = error
			setTimeout(() => {
				this.showAlertError = false
			}, 5000)
		},
		showSuccessMessage(msg) {
			window.scrollTo(0, 0)
			this.showAlertSuccess = true
			this.txt.successMessage = msg
			setTimeout(() => {
				this.showAlertSuccess = false
			}, 5000)
		},
		async getUsers() {
			try {
				this.loadingData = true
				const r = await axios.get(`${config.baseAPIurl}/user-manager/user`, {
					params: { currentPageNumber: this.currentPageNumber },
				})
				this.userlist = r.data
			} catch (error) {
				console.log(error)
			} finally {
				this.loadingData = false
			}
		},
		async searchKeycloakUsers() {
			if (this.search == '') {
				await this.getKeycloakUsersCount()
				this.rowsPerPage = 25
				this.itemsPerPage = 25
				this.currentPageNumber = 1
				this.pagination = this.basePagination
				this.shouldPaginate = true
				return
			}
			try {
				this.shouldPaginate = false
				this.loadingData = true
				this.userlist = []
				this.totalNumberOfUsers = 0
				const r = await axios.get(`${config.baseAPIurl}/user-manager/user-search`, {
					params: { searchString: this.search },
				})
				this.userlist = r.data
				this.totalNumberOfUsers = r.data.length
				this.rowsPerPage = r.data.length
				this.itemsPerPage = r.data.length
				this.pagination = {
					rowsPerPage: r.data.length,
					descending: false,
					page: 1,
				}
			} catch (err) {
				console.log(err)
			} finally {
				this.loadingData = false
			}
		},
		async getKeycloakUsersCount() {
			try {
				this.loadingData = true
				const r = await axios.get(`${config.baseAPIurl}/user-manager/keycloak-user-count`)
				this.totalNumberOfUsers = r.data
			} catch (err) {
				console.log(err)
			}
		},
		async openEditDialog(user) {
			this.dialogEditUser = true
			await this.editUser(user)
		},
		async editUser(user) {
			try {
				this.selectedUser = user
				const r = await axios.get(`${config.baseAPIurl}/user-manager/user?id=${user.id}`)
				this.updateRight(r.data)
			} catch (error) {
				this.handleError(error)
				this.dialogEditUser = false
			}
		},
		updateRight(updatedRight) {
			this.selectedUserRights = updatedRight.map(right => right )
		},
		async deleteRight(item) {
			try {
				await axios.delete(`${config.baseAPIurl}/user-manager/rights`, {
					params: {
						right_id: item.right_id,
					},
				})
				this.selectedUserRights = this.selectedUserRights.filter(el => el.right_id != item.right_id)
			} catch (error) {
				this.handleError(error)
			} finally {
				this.getUsers()
				this.getKeycloakUsersCount()
			}
		},
		async onRightAdded() {
			this.editUser(this.selectedUser)
			this.getUsers()
		},
		async onUserDetailsSaved() {
			this.getUsers()
		},
		async confirmedEditRight(selectedUserRights) {
			this.loadingData = true
			try {
				await axios.put(`${config.baseAPIurl}/user-manager/rights`, { selectedUserRights })
			} catch (error) {
				this.handleError(error)
			} finally {
				this.dialogEditUser = true
				this.loadingData = false
				this.editUser(this.selectedUser)
				this.getUsers()
				this.getKeycloakUsersCount()
			}
		},
		deleteUser(user) {
			this.deleteDialogKey += 1
			this.dialogConfirmDeleteUser = true
			this.selectedUserForDeleting = user
		},
		resetPassword(user) {
			this.passwordDialogKey += 1
			this.dialogConfirmPasswordChange = true
			this.selectedUser = user
		},
		async changePasswordClick(userSelected) {
			try {
				this.loadingData = true
				await axios.put(config.baseAPIurl + '/user-manager/keycloak-user-password',
					{ user: userSelected },
				)
				this.showSuccessMessage('Password successfully updated')
			} catch (error) {
				this.handleError(error)
			} finally {
				this.dialogConfirmPasswordChange = false
				this.loadingData = false
			}
		},
		async deleteUserClick(userToDelete) {
			try {
				this.loadingData = true
				await axios.delete(config.baseAPIurl + '/user-manager/user',
					{ params: { user: userToDelete } },
				)
				this.selectedUserForDeleting = {}
				this.dialogConfirmDeleteUser = false
				this.userlist = []
				this.getUsers()
				this.showSuccessMessage('User successfully deleted')
			} catch(error) {
				this.handleError(error)
			} finally {
				this.dialogConfirmDeleteUser = false
				this.loadingData = false
			}
		},
		getDataFromApiSearch: debounce(function() {
			this.searchKeycloakUsers()
		}, 1500),
	},
	watch: {
		pagination: {
			handler(pagination) {
				if (this.shouldPaginate && this.isMounted) {
					this.currentPageNumber = pagination.page
					this.getUsers()
				}
			},
			deep: true,
		},
	},
	mounted() {
		this.$nextTick(() => {
			this.isMounted = true
			this.getUsers()
			this.getKeycloakUsersCount()
		})
	},
}
</script>

<style scoped>
.formEdit {
	padding: 24px;
	margin: 0;
	height: 100%;
	overflow: hidden;
}

.createNewUserBtn {
	margin-top: 25px;
	margin-bottom: 45px;
}

.createNewUserBtnIcon {
	padding-right: 10px;
}

</style>
